export default "__VITE_ASSET__DrRTaKI6__"